var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQusMandatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.998,
    height: 15.997,
    viewBox: "0 0 15.998 15.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e11e5a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18326.104 -6676)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18326.104 6676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.815,8.579A8.011,8.011,0,0,0,9.23,20.233,8.008,8.008,0,0,0,24.1,16.111,8.126,8.126,0,0,0,18.815,8.579Zm.565,11.572L16.1,16.875l-3.277,3.277a.542.542,0,0,1-.767-.767l3.277-3.277-3.277-3.277a.542.542,0,0,1,.767-.767L16.1,15.342l3.277-3.277a.542.542,0,0,1,.767.767L16.87,16.108l3.277,3.277A.542.542,0,0,1,19.38,20.152Z",
    transform: "translate(-8.104 -8.109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQusMandatory);
export default __webpack_public_path__ + "static/media/QusMandatory.9994700c7ee422661a80550bdf7f72a4.svg";
export { ForwardRef as ReactComponent };